export default "__VITE_ASSET__e162edfa__"